import debounce from 'lodash/debounce';
import { useEffect, useRef, useState } from 'react';
import { CkRichTextEditor } from '../CkRichTextEditor';

export interface TextEditorBlockProps {
  onSave: (arg: string) => void;
  text: string;
  assetServiceUri: string;
}
export function TextEditorBlock(props: TextEditorBlockProps) {
  const { onSave, text, assetServiceUri } = props;

  const debouncedChangeHandler = debounce((_: any, editor: any) => {
    onSave(editor.getData());
  }, 2500);
  const count = useRef(0);
  const [inputValue, setInputValue] = useState('');
  useEffect(() => {
    if (text && count.current < 1) {
      setInputValue(text);
      count.current++;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, count]);
  return (
    <div>
      <CkRichTextEditor
        // withPasting={false}
        value={inputValue}
        onChange={debouncedChangeHandler}
        urlPrefix={assetServiceUri}
      />
    </div>
  );
}

export default TextEditorBlock;
